import ModalActions from "./ModalActions";

export default ModalActions;
